var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.026.917a.75.75 0 00-1.06.112L3.792 3.75h.96l1.798-2.253.578.472L5.68 3.75h.966L7.71 2.442l1.288 1.052-.223.256H9c.224 0 .446.033.66.098a.75.75 0 00-.188-.933L7.027.917zM2.25 4.125a.375.375 0 01.375-.375h.418L3.64 3H2.625A1.125 1.125 0 001.5 4.125v4.5A1.875 1.875 0 003.375 10.5H9A1.5 1.5 0 0010.5 9V6A1.5 1.5 0 009 4.5H2.625a.375.375 0 01-.375-.375zM7.875 7.5h.75a.375.375 0 010 .75h-.75a.375.375 0 010-.75z",
    fill: "#049A80"
  })));
}
export default SvgGreenWallet;